import { defineStore } from 'pinia';
import { type UsetifulTour } from '../types';
import { useSessionStorage, useLocalStorage } from '@vueuse/core';
import { type Milestone, type ChecklistItems } from '@/generated/graphql';
import { watch } from 'vue';
import { Views } from '@/features/HelpStation';

export const useHelpStationStore = defineStore('helpStation', {
	state: () => {
		const isSidebarOpen = useSessionStorage('isSidebarOpen', false);
		const view = useSessionStorage('view', Views.MAIN_VIEW);
		const previousView = useSessionStorage('previousView', '');

		watch(view, (now, prev) => {
			previousView.value = prev;
		});

		watch(isSidebarOpen, (isOpen) => {
			if (!isOpen) {
				view.value = '';
			}
		});

		return {
			isSidebarOpen,
			view,
			previousView,
			tours: [] as UsetifulTour[],
			isVideoModalOpen: false,
			currentVideoUrl: '',
			currentVideoName: '',
			projectChecklist: [] as Array<ChecklistItems> | undefined,
			getStartedChecklist: [] as Array<ChecklistItems> | undefined,
			isGetStartedActionCardCompleted: false,
			setUpSiteChecklist: [] as Array<ChecklistItems> | undefined,
			learnMoreChecklist: [] as Array<ChecklistItems> | undefined,
			startHandleAnimationTimestampMs: useSessionStorage(
				'startHandleAnimationTimestampMs',
				NaN as number
			),
			hasUserClickedScrollIndicator: useLocalStorage(
				'hasUserClickedScrollIndicator',
				false as boolean
			),
			shouldShowScrollIndicator: false,
			lastExpandedAccordionCardKey: useSessionStorage(
				'lastExpandedAccordionCardKey',
				undefined as undefined | string
			),
			isBackgroundJobsBarVisible: false,
			isProjectChecklistLocalStorageEmpty: false,
			isGetStartedChecklistLocalStorageEmpty: false,
			hasUserClickedHelpButtonWithBubble: useLocalStorage(
				'hasUserClickedHelpButtonWithBubble',
				false
			),
			hasUserClickedProductUpdatesCard: useLocalStorage(
				'hasUserClickedProductUpdatesCard',
				false
			),
			successMessageCustomKey: '',
			hasUserOpenedHelpStation: useLocalStorage(
				'hasUserOpenedHelpStation',
				false
			),
			hasUserReviewedBooking: useLocalStorage(
				'hasUserReviewedBooking',
				false
			),
			milestones: [] as Array<Milestone> | undefined,
		};
	},
});
